var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransactionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 114,
    viewBox: "0 0 130 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 128,
    height: 112,
    rx: 8,
    stroke: "#2369CC",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.7096 20.2904L98.4167 20.9975L99.1238 20.2904L104 15.4142V87.6111C104 94.3433 98.5683 99.7761 91.8365 99.7778C91.8355 99.7778 91.8344 99.7778 91.8334 99.7778L52.6527 99.5176C55.1738 97.1488 57.1755 94.4901 58.3602 91.2152C59.8472 87.1045 60.0032 82.1451 58.4724 75.7666L58.3951 75.4444H86.4445V87.6111C86.4445 90.5773 88.8672 93 91.8334 93C94.7995 93 97.2222 90.5773 97.2222 87.6111V26.1667V25.1667H96.2222H47.9445H46.9445V26.1667V67.6035L46.3128 67.1734L45.8475 66.8566L45.3353 67.09L40.1667 69.4454V15.4142L45.0429 20.2904L45.75 20.9975L46.4571 20.2904L52.3334 14.4142L58.2096 20.2904L58.9167 20.9975L59.6238 20.2904L65.5 14.4142L71.3763 20.2904L72.0834 20.9975L72.7905 20.2904L78.6667 14.4142L84.5429 20.2904L85.25 20.9975L85.9571 20.2904L91.8334 14.4142L97.7096 20.2904Z",
    stroke: "#2369CC",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3334 35.9445H75.6667C76.7713 35.9445 77.6667 36.8399 77.6667 37.9445V40.7222C77.6667 41.8268 76.7713 42.7222 75.6667 42.7222H55.3334C54.2288 42.7222 53.3334 41.8268 53.3334 40.7222V37.9445C53.3334 36.8399 54.2288 35.9445 55.3334 35.9445Z",
    stroke: "#2369CC",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0556 35.9445H88.8334C89.9379 35.9445 90.8334 36.8399 90.8334 37.9445V40.7222C90.8334 41.8268 89.9379 42.7222 88.8334 42.7222H86.0556C84.951 42.7222 84.0556 41.8268 84.0556 40.7222V37.9445C84.0556 36.8399 84.951 35.9445 86.0556 35.9445Z",
    stroke: "#2369CC",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3334 49.1111H75.6667C76.7713 49.1111 77.6667 50.0065 77.6667 51.1111V53.8889C77.6667 54.9935 76.7713 55.8889 75.6667 55.8889H55.3334C54.2288 55.8889 53.3334 54.9935 53.3334 53.8889V51.1111C53.3334 50.0065 54.2288 49.1111 55.3334 49.1111Z",
    stroke: "#2369CC",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3333 63.1111H75.6666C76.7712 63.1111 77.6666 64.0065 77.6666 65.1111V67.8889C77.6666 68.9935 76.7712 69.8889 75.6666 69.8889H55.3333C54.2287 69.8889 53.3333 68.9935 53.3333 67.8889V65.1111C53.3333 64.0065 54.2287 63.1111 55.3333 63.1111Z",
    stroke: "#2369CC",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0556 49.1111H88.8334C89.9379 49.1111 90.8334 50.0065 90.8334 51.1111V53.8889C90.8334 54.9935 89.9379 55.8889 88.8334 55.8889H86.0556C84.951 55.8889 84.0556 54.9935 84.0556 53.8889V51.1111C84.0556 50.0065 84.951 49.1111 86.0556 49.1111Z",
    stroke: "#2369CC",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0555 63.1111H88.8333C89.9379 63.1111 90.8333 64.0065 90.8333 65.1111V67.8889C90.8333 68.9935 89.9379 69.8889 88.8333 69.8889H86.0555C84.951 69.8889 84.0555 68.9935 84.0555 67.8889V65.1111C84.0555 64.0065 84.951 63.1111 86.0555 63.1111Z",
    stroke: "#2369CC",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1429 66C32.7295 66 24.2857 74.5078 24.2857 85H18L26.1505 93.2122L26.2971 93.5078L34.7619 85H28.4762C28.4762 76.83 35.0343 70.2222 43.1429 70.2222C51.2514 70.2222 57.8095 76.83 57.8095 85C57.8095 93.17 51.2514 99.7778 43.1429 99.7778C39.099 99.7778 35.4324 98.11 32.7924 95.4289L29.8171 98.4267C33.2324 101.868 37.9257 104 43.1429 104C53.5562 104 62 95.4922 62 85C62 74.5078 53.5562 66 43.1429 66ZM41.0476 76.5556V87.1111L49.9524 92.4311L51.5657 89.7289L44.1905 85.3167V76.5556H41.0476Z",
    fill: "#2369CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionIcon);
export default __webpack_public_path__ + "static/media/transaction-icon.aca0ff77df118d649b5803b7173379a8.svg";
export { ForwardRef as ReactComponent };